!(function () {
  "use strict";
  customElements.get("pl-cart-upsell") ||
    customElements.define(
      "pl-cart-upsell",
      class extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.button = this.querySelector("button");
          const id = this.getAttribute("data-line-item-id");
          const quantity = this.getAttribute("data-line-item-quantity");
          const selling_plan = this.getAttribute("data-selling-plan-id");
          this.button.addEventListener("click", (e)=>this.onButtonClick(e,id, quantity, selling_plan));
        }
        onButtonClick(e,id, quantity, selling_plan) {
          e.preventDefault();
          this.dispatchEvent(
            new CustomEvent("theme:cart:upsell", {
              detail: {
                id,
                quantity,
                selling_plan,
              },
              bubbles: true,
            })
          );
        }
      }
    );
})();
